import { VariableValueSimulator } from '@iotize/virtual-tap';

export class CounterValueSimulator implements VariableValueSimulator {
  private lastValue: number;
  constructor(
    private options: {
      start: number;
      step: number;
      max: number;
    } = {
      start: 0,
      step: 1,
      max: Math.pow(2, 8),
    }
  ) {
    this.lastValue = this.options.start;
  }

  generateNextValue(): number | number[] {
    this.lastValue += this.options.step;
    if (this.lastValue > this.options.max) {
      this.lastValue = this.options.start;
    }
    return this.lastValue;
  }
}
